import { VALIDATE_SPINE } from "../../../constants/Constants";
import { spineValidateData } from "./SpineValidationData";
import {where,groupBy,pluck,find} from 'underscore';

export const validateSpine = (inputObj) => {
    // console.log("INput is ");
    // console.log(inputObj);
	var obj1 = JSON.parse(JSON.stringify(spineValidateData));
	
	var keys2;
	var value2;
	var value3;
	var arr3;
	var value4;
	var f;
	var keys1 = Object.keys(inputObj);
	var spineAnnotations = ["50","52","53"];
	var foundCnt = 0;
	for(var i=0; i<keys1.length; i++) {
		if(spineAnnotations.includes(keys1[i])) {
			foundCnt++;
		}
	}
	
	if(foundCnt > 1) {
		return {error:1, message:VALIDATE_SPINE._iselectOneTechnique};
	}
	
	var tempResult = validateSpineFractureCombination(keys1);
	if(tempResult != null) {
		return tempResult;
	}
	
	keys1.forEach( function(value, array, index) {
			if(value == undefined) {
				return;
			}
			if(inputObj[value] == undefined) {
				return;
			}
			keys2 = Object.keys(inputObj[value]);
			value2 = value;
			keys2.forEach( function(v2, a2, i2) {
				// console.log('Sub opt is ' + v2);
				arr3 = inputObj[value2][v2];
				value3 = v2;
				//Search for suboptions found in this list
				arr3.forEach(function (v3,a3,i3) {
					value4 = v3;
					// console.log(v3);
					/*obj[62].options[value3].subOpts.forEach( function(v4,a4,i4) {
						if(value4 === parseInt(v4.suboptionId)) {
							v4.selected = true;
						}
					});*/
					/*f = _.find(obj, function(a){
							return a.suboptionId === v3;
						});*/
					f = where(obj1,{subOptionId:v3});
					if(f.length > 0) {
						f[0].selected = true;
					}
				}) ;
			});
		});

		var selectedFilter = {selected:true};
        // console.log("___ is");
        // console.log(obj1);
		obj1 = where(obj1, selectedFilter);
		// console.log(obj1);
		if(obj1.length == 0) {
			//Nothing is selected returning success object
			return null;
		}
		
		var vResult = validateCombination(obj1);
		if(vResult != null) {
			return vResult;
		}
		
		var filter = {groupNumber:3};
		var group3Data = where(obj1, filter);
		
		if(group3Data && group3Data.length > 1) {
			return {error:1, message:VALIDATE_SPINE._imessageSelectEitherScolosisLumbarOrScolasisThoracolumbar};
		}
		
		vResult = validateSpineGroup4(obj1);
		if(vResult != null) {
			return vResult;
		}
		
		vResult = validateSpineGroup5(obj1);
		if(vResult != null) {
			return vResult;
		}
		
		vResult = validateSpineGroup6(obj1);
		if(vResult != null) {
			return vResult;
		}

		vResult = validateSpineGroup7(obj1);
		if(vResult != null) {
			return vResult;
		}
		
		vResult = validateSpineGroup8(obj1);
		if(vResult != null) {
			return vResult;
		}
		
		vResult = validateSpineGroup9(obj1);
		if(vResult != null) {
			return vResult;
		}
				
		vResult = validateSpineGroup10(obj1);
		if(vResult != null) {
			return vResult;
		}
		
		return null;
}

function validateSpineGroup10(obj1) {
	var filter = {groupNumber:10};
	var group10Data = where(obj1, filter);
	
	if(group10Data && group10Data.length > 1) {
		return {error:1, message:VALIDATE_SPINE._imessageSelectEitherAbnormalSclerosedOrAbnormalErosion};
	}
	
	return null;
}

function validateCombination(obj1) {
	var ids = ["50","52","53"];
	cnt =groupBy(obj1, function(a){return a.pathologyId ;});
	var keys = Object.keys(cnt);
	
	var cnt = 0;
	for(var i=0; i<keys.length; i++) {
		if(ids.includes(keys[i])) {
			cnt++;
		}
	}
	
	if(cnt > 1) {
		return {error:1, message: VALIDATE_SPINE._iselectOneTechnique};
	}
	return null;
}

function validateSpineGroup4(obj1) {
	var filter = {groupNumber:4};
	var group4Data = where(obj1, filter);
	
	var lst1 = ["Lumbar Mild", "Lumbar Moderate", "Lumbar Severe"];
	var lst2 = ["Thoracolumbar Mild", "Thoracolumbar Moderate", "Thoracolumbar Severe"];
	
	/*var lst1Data = _.filter(group4Data, function(a) {
		return lst1.includes(a.pathalogyOptionName);
	});
	
	var lst2Data = _.filter(group4Data, function(a) {
		return lst2.includes(a.pathalogyOptionName);
	});
	
	if(checkLstCntByGroup(lst1Data) > 1) {
		return {error:1, message:'Select only one option from Kyphosis->Lumbar Mild/Moderate/Severe'};
	}
	
	if(checkLstCntByGroup(lst2Data) > 1) {
		return {error:1, message:'Select only one option from Kyphosis->Thoracolumbar Mild/Moderate/Severe'};
	}*/
	
	var groups = groupBy(group4Data, function(a){return a.subOptionName;});
	let result = checkSuboptsOverlappting(groups, 'Kyphosis');
	if(result != null) {
		return result;
	}
	
	return null;
}

function validateSpineGroup5(obj1) {
	var filter = {groupNumber:5};
	var group5Data = where(obj1, filter);
	
	/*var lst1 = ["Wedging WITH Retropulsion Mild", "Wedging WITH Retropulsion Moderate", "Wedging WITH Retropulsion Severe"];
	var lst2 = ["Wedging WITHOUT Retropulsion Mild", "Wedging WITHOUT Retropulsion Moderate", "Wedging WITHOUT Retropulsion Severe"];
	
	var lst1Data = _.filter(group5Data, function(a) {
		return lst1.includes(a.pathalogyOptionName);
	});
	
	var lst2Data = _.filter(group5Data, function(a) {
		return lst2.includes(a.pathalogyOptionName);
	});
	
	if(checkLstCntByGroup(lst1Data) > 1) {
		return {error:1, message:'Select only one option from Vertebral Body Height->Wedging WITH Retropulsion Mild/Moderate/Severe'};
	}
	
	if(checkLstCntByGroup(lst2Data) > 1) {
		return {error:1, message:'Select only one option from Vertebral Body Height->Wedging WITHOUT Retropulsion Mild/Moderate/Severe'};
	}*/
	
	var groups = groupBy(group5Data, function(a){return a.subOptionName;});
	
	var result = null;
	result = checkSuboptsOverlappting(groups, 'Vertebral Body Height');
	if(result != null) {
		return result;
	}
	return null;
}

function validateSpineGroup7(obj1) {
	var filter = {groupNumber:7};
	var group7Data = where(obj1, filter);
	
	var lst1 = ["Nonbridging Small", "Nonbridging Medium Sized", "Nonbridging Large"];
	var lst2 = ["Bridging Small", "Bridging Medium Sized", "Bridging Large"];
	
	/*var lst1Data = _.filter(group6Data, function(a) {
		return lst1.includes(a.pathalogyOptionName);
	});
	
	var lst2Data = _.filter(group6Data, function(a) {
		return lst2.includes(a.pathalogyOptionName);
	});
	
	if(checkLstCntByGroup(lst1Data) > 1) {
		return {error:1, message:'Select only one option from Osteophytes->Nonbridging Small/Medium Sized/Large'};
	}
	
	if(checkLstCntByGroup(lst2Data) > 1) {
		return {error:1, message:'Select only one option from Osteophytes->Bridging Small/Medium Sized/Large'};
	}*/
	
	var groups = groupBy(group7Data, function(a){return a.subOptionName;});
	let result = checkSuboptsOverlappting(groups, 'Osteophytes');
	if(result != null) {
		return result;
	}

	return null;
}

function validateSpineFractureCombination(allKeys) {
	var spineAnnotations = ["50","52","53"];
	//In case of prod use 55, test use 54.
	//FIXME: Use asset id instead since it will be fix for all environment.
	var fractureAnnotation = "55";
	
	var fractureFound = false;
	
	for(var i=0; i<allKeys.length; i++) {
		if(allKeys.includes(fractureAnnotation)) {
			fractureFound = true;
		}
	}
	
	if(!fractureFound) {
		return null;
	}
	
	var aFound = false;
	for(var i=0; i<allKeys.length; i++) {
		if(spineAnnotations.includes(allKeys[i])) {
			aFound = true;
		}
	}
	
	if(!aFound) {
		return {error:1, 
			message:VALIDATE_SPINE._imessageLumbarSpineFractureShouldBeWithSpineOrLumbarWithObliquesOrLumbarWithFlexionAndExtension}; 
	}
	
	return null;
}

function validateSpineGroup6(obj1) {
	var filter = {groupNumber:6};
	var group6Data = where(obj1, filter);
	var groups = groupBy(group6Data, function(a){return a.subOptionName;});
	
	var result = null;
	result = checkSuboptsOverlappting(groups, 'Vertebral Body Height(B)');
	if(result != null) {
		return result;
	}
	return null;
}


function validateSpineGroup8(obj1) {
	var filter = {groupNumber:8};
	var group8Data = where(obj1, filter);
	
	/*var cnt = _.groupBy(group7Data, function(a){return a.pathologyOptionId ;});
	var keys = Object.keys(cnt);
	
	if(keys.length > 1) {
		return {error:1, message:'Select either IVD->Reduced Mild/Moderate/Sever option'};
	}*/
	
	var groups = groupBy(group8Data, function(a){return a.subOptionName;});
	var result = checkSuboptsOverlappting(groups, 'IVD');
	if(result != null) {
		return result;
	}
	return null;
}

function validateSpineGroup9(obj1) {
	var filter = {selected:true, groupNumber:9};
	var group9Data = where(obj1, filter);
	var data = pluck(group9Data, 'pathalogyOptionName');
	if(data && data.length == 1 && data[0] === 'Listhesis') {
		return {error:1, message:VALIDATE_SPINE._imessageSelectApplicableSuboptionFromLysisLevel};
	}
	if(group9Data && group9Data.length == 0) {
		return null;
	}
	var checkLevel = find(obj1, function(a){return a.pathalogyOptionName == "Level";});

	var check2 = pluck(group9Data, 'pathalogyOptionName');
	var optionFilter = ["Listhesis Mild","Listhesis Moderate", "Listhesis Severe"];
	
	var cnt = 0;
	var absCnt = 0;
	for(var i=0; i<check2.length; i++) {
		if(optionFilter.includes(check2[i])) {
			cnt++;
		}
		if(check2[i] == 'Listhesis') {
			absCnt = 1;
		}
	}
	
	if(checkLevel == undefined) {
		//Check for overlapping group.
		var groups = groupBy(group9Data, function(a){return a.subOptionName;});
		var result = checkSuboptsOverlappting(groups, 'Lysis');
		if(result != null) {
			return result;
		}
		
		if(absCnt > 0) {
			return {errorr:1, message:VALIDATE_SPINE._imessageListhesisCanNotBeAbsent};
		}
		return null;
	}

	if(absCnt > 0 && cnt > 0) {
		return {error:1,message:VALIDATE_SPINE._imessageAbsentOptionCannotBeUsedWithLysisListhesisMildModerateSevere};
	}
	if(cnt > 1) {
		return {error:1, message:VALIDATE_SPINE._imessageSelectOnlyOneOptionFromLysisListhesisMildModerateSevere}
	}

/*	if(group8Groups.length > 1) {
		return {
			error:1,message:'Select only one option from Listhesis Mild/Moderate/Sever'
		};
	}*/
	return null;
}

function checkSuboptsOverlappting(groups, groupName) {
	var gk = Object.keys(groups);
	var obj;
	for(var i=0; i<gk.length; i++) {
		obj = groups[gk[i]];
		if(obj.length > 1) {
			var e = obj[0];
			var opts = pluck(obj, 'pathalogyOptionName');
			var lOpts = [];
			for(var j=0; j<opts.length; j++) {
				// TODO
				// lOpts[j] = getLocaleValue(opts[j]);
				lOpts[j] = opts[j];
			}
			//TODO
			// return {error:1, message:VALIDATE_SPINE._iPleaseSelect + getLocaleValue(e.subOptionName) + VALIDATE_SPINE._iOnlyOnceFrom + getLocaleValue(groupName) + ' -> ' + lOpts.join(VALIDATE_SPINE._iOr)};
			return null;
		}
	}
	return null;
}

export function checkLstCntByGroup(lst) {
	var l1 = groupBy(lst, function(a){return a.pathalogyOptionName;});
	var k = Object.keys(l1);
	return k.length;
}
